export default __webpack_public_path__ + "static/media/portfolio-fmfa.93fd7d47.png";